import { createSlice } from '@reduxjs/toolkit';
import { getLocalData, setLocalData } from '../utils/helper';

export interface Organisation {
  access_uuid: string;
  organisation_uuid: string;
  organisation_name: string;
  corporate_type: string;
  lives_covered: number;
  employee_count: number;
  employer_count: number;
  is_default: boolean;
}

interface initialStateInterface {
  entities: Array<Organisation>;
  chosenEntity: Organisation | null;
  canChooseEntity: boolean;
  totalAdminCount: number;
}

const normalizeChosenEntity = (entity: Organisation | { chosenEntity?: Organisation } | null): Organisation | null => {
  if (entity && 'chosenEntity' in entity) {
    return entity.chosenEntity || null;
  }
  return entity as Organisation | null;
};

const initialState: initialStateInterface = {
  entities: [],
  chosenEntity: normalizeChosenEntity(getLocalData('chosenEntity') || null),
  canChooseEntity: getLocalData('canChooseEntity') || false,
  totalAdminCount: 0
};

const multiEntitySlice = createSlice({
  name: 'multiEntity',
  initialState,
  reducers: {
    setEntities: (state, action) => {
      state.entities = action.payload.entities;
      let canChooseEntity = action.payload?.canChooseEntity;
      state.canChooseEntity = canChooseEntity;
      state.totalAdminCount = action?.payload?.totalAdminCount;
      setLocalData('canChooseEntity', canChooseEntity);
    },
    setChosenEntity: (state, action) => {
      const chosenEntity = normalizeChosenEntity(action.payload);
      state.chosenEntity = chosenEntity;
      setLocalData('chosenEntity', chosenEntity);
    },
    clearData: (state) => {
      return { ...initialState };
    },
  },
});

export const multiEntityActions = multiEntitySlice.actions;
export default multiEntitySlice.reducer;
